import * as React from "react";

type Wrapper = React.ReactElement | React.ElementType;

export type ConditionalWrapperProps = {
  condition: boolean;
  mainWrapper: Wrapper;
  altWrapper?: Wrapper;
  children: React.ReactNode;
};

function wrapWith(wrapper: Wrapper, children: React.ReactNode) {
  // Allow passing either a ready element or a component type
  const element = React.isValidElement(wrapper)
    ? wrapper
    : React.createElement(wrapper as React.ElementType, null);

  // Clone and inject children (array or single is fine for ReactNode)
  // @ts-ignore
  return React.cloneElement(element, element.props, children);
}

export const ConditionalWrapper: React.FC<ConditionalWrapperProps> = ({
                                                                        condition,
                                                                        mainWrapper,
                                                                        altWrapper,
                                                                        children,
                                                                      }) => {
  if (condition) return wrapWith(mainWrapper, children);
  if (altWrapper) return wrapWith(altWrapper, children);
  // condition === false and no altWrapper -> render children as-is (no container)
  return <>{children}</>;
};
